import React from 'react'

export default function AdvdecdFaq({marketdata}) { 
    return (
        <><h3>FAQs</h3>
            <div className='today-faqs'>
                <h3>What is advance decline ratio?</h3>
                <p>Advance-Decline Ratio is a tool used to compare the number of stocks that closed higher with the number of stocks that closed lower than their previous day's closing prices.</p>

                <h3>How do you calculate advance and decline ratio?</h3>
                <p>To calculate the advance-decline ratio, divide the number of advancing shares by the number of declining shares.</p>

                <h3>How do you read advance decline ratio?</h3>
                <p>The advance/decline ratio is a market breadth indicator. A rising A/D ratio value suggests that the market is gaining momentum, whereas a falling value suggests that the market may be losing momentum.</p>

                <h3>How to interpret advance decline ratio?</h3>
                <p>A high advance-decline ratio on a standalone basis might signal an overbought market, while a low ratio means an oversold market. Meanwhile, a steadily increasing ratio might signal a bullish trend, and the opposite would indicate a bearish trend.</p>
                {marketdata && marketdata.length > 0 && <>
                <h3>What is advance decline ratio nse today?</h3>
                <p>NSE advance decline ratio today is <b> {marketdata[0]['columnone']}</b> advancing stocks and <b>{marketdata[0]['columntwo']}</b> declining stocks.</p>
                </>}
            </div>
        </>
    )
}
